import axios from 'axios';

// Constrói a URL base usando o hostname atual ou o IP específico
const getBaseURL = () => {
  // Obter o hostname e protocolo atuais
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  
  console.log('Configurando API para hostname:', hostname);
  console.log('Protocolo atual:', protocol);
  
  // Em ambiente de produção na AWS (IP público ou privado da AWS)
  if (hostname === '15.228.60.13' || hostname === '172.31.46.23') {
    // No ambiente de produção, a API está no mesmo host sem porta específica
    const baseUrl = `${protocol}//${hostname}`;
    console.log('Ambiente de produção detectado, usando URL base:', baseUrl);
    return baseUrl;
  }
  
  // Em ambiente de desenvolvimento local
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '192.168.0.112') {
    const baseUrl = `${protocol}//${hostname}:5000`;
    console.log('Ambiente de desenvolvimento detectado, usando URL base:', baseUrl);
    return baseUrl;
  }
  
  // Fallback para qualquer outro caso - usar o mesmo hostname sem porta específica
  const baseUrl = `${protocol}//${hostname}`;
  console.log('Usando URL base padrão:', baseUrl);
  return baseUrl;
};

const baseURL = getBaseURL();
const API_URL = baseURL;

console.log('API configurada com baseURL final:', baseURL);

// Variável para evitar múltiplos redirecionamentos
let isRedirecting = false;

const api = axios.create({
  baseURL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },
  withCredentials: true // Habilita o envio de cookies
});

// Interceptor para adicionar o token em todas as requisições
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    console.log('Token adicionado ao header:', `Bearer ${token.substring(0, 15)}...`);
  } else {
    console.log('Nenhum token encontrado para adicionar ao header');
  }
  
  // Adiciona headers para CORS
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  
  console.log('Enviando requisição para:', config.url);
  console.log('Método:', config.method);
  console.log('URL completa:', config.baseURL + config.url);
  
  return config;
}, error => {
  console.error('Erro no interceptor de requisição:', error);
  return Promise.reject(error);
});

// Interceptor para tratar respostas e erros
api.interceptors.response.use(
  response => {
    console.log('Resposta recebida com sucesso:', {
      url: response.config.url,
      status: response.status,
      statusText: response.statusText
    });
    return response;
  },
  error => {
    console.log('API Error Interceptor:', error);
    
    // Informações detalhadas sobre a requisição que falhou
    const requestInfo = {
      url: error.config?.url,
      baseURL: error.config?.baseURL,
      method: error.config?.method,
      headers: error.config?.headers ? {
        authorization: error.config.headers.Authorization ? 'Bearer [REDACTED]' : 'Nenhum',
        contentType: error.config.headers['Content-Type'],
        accept: error.config.headers['Accept']
      } : 'Nenhum header disponivel'
    };
    
    console.log('Detalhes da requisição com falha:', requestInfo);
    
    if (error.response) {
      console.log('Error response status:', error.response.status);
      console.log('Error response data:', error.response.data);
      
      // Se o erro for relacionado a token inválido ou expirado
      if (error.response.status === 401) {
        console.log('Erro 401 detectado - Autenticação falhou');
        
        // Verificar se não estamos em uma rota de login para evitar loop
        const isLoginPage = window.location.pathname.includes('/login');
        const isAuthRequest = error.config.url.includes('/api/auth/login');
        
        console.log('Contexto da requisição:', {
          isLoginPage,
          isAuthRequest,
          isRedirecting,
          currentPath: window.location.pathname
        });
        
        if (!isLoginPage && !isAuthRequest && !isRedirecting) {
          console.log('Redirecionando para login devido a erro 401');
          
          // Evitar múltiplos redirecionamentos
          isRedirecting = true;
          
          // Limpa os dados de autenticação
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          
          // Redireciona para a página de login
          setTimeout(() => {
            console.log('Redirecionando para /login');
            window.location.href = '/login';
            // Resetar a flag após o redirecionamento
            setTimeout(() => {
              isRedirecting = false;
            }, 1000);
          }, 100);
          
          return Promise.reject({ message: 'Sessão expirada. Por favor, faça login novamente.' });
        }
      } else if (error.response.status === 403) {
        // Tratamento específico para erros de permissão
        console.log('Erro 403 detectado - Acesso negado');
        
        // Formatar o erro para facilitar o tratamento nos componentes
        const errorData = {
          status: 403,
          message: error.response.data?.message || 'Acesso negado',
          details: error.response.data?.details || 'Você não tem permissão para acessar este recurso.',
          resource: error.config.url,
          method: error.config.method
        };
        
        console.log('Detalhes do erro de permissão:', errorData);
        
        // Não redirecionar automaticamente, apenas retornar o erro formatado
        // para que o componente possa exibir a mensagem adequada
        return Promise.reject(errorData);
      }
      
      // Para outros erros, retornar os dados da resposta de erro
      return Promise.reject(error.response.data);
    }
    if (error.request) {
      console.log('Erro de conexão com o servidor:', error.request);
      return Promise.reject({ message: 'Erro de conexão com o servidor' });
    }
    console.log('Erro ao processar requisição:', error.message);
    return Promise.reject({ message: 'Erro ao processar requisição' });
  }
);

// Função para adicionar timestamp a URLs de imagens para evitar cache
const getPhotoUrl = (path) => {
  if (!path) return null;
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  const timestamp = new Date().getTime();
  return `${baseURL}/${cleanPath}?t=${timestamp}`;
};

// Exportar a instância do axios configurada
export default api;

// Exportar a URL base para uso em outros lugares
export { API_URL, baseURL, getPhotoUrl };

// Serviços de autenticação
export const authService = {
  login: (data) => api.post('/api/auth/login', data)
};

// Serviços de usuário
export const userService = {
  getAll: () => api.get('/api/users'),
  listarUsuarios: () => api.get('/api/users'),
  getById: (id) => api.get(`/api/users/${id}`),
  obterUsuario: (id) => api.get(`/api/users/${id}`),
  create: (data) => api.post('/api/users', data),
  update: (id, data) => api.put(`/api/users/${id}`, data),
  atualizarUsuario: (id, data) => api.put(`/api/users/${id}`, data),
  delete: (id) => api.delete(`/api/users/${id}`),
  toggleActive: (id) => api.patch(`/api/users/${id}/toggle-active`),
  debugLaresAssociations: (userId, larId, testarCriacao) => {
    let url = `/api/users/debug/${userId}`;
    if (larId) url += `?larId=${larId}`;
    if (testarCriacao) url += `${larId ? '&' : '?'}testarCriacao=true`;
    return api.get(url);
  },
  updatePhoto: (id, formData) => {
    console.log(`Atualizando foto do usuário ${id}`);
    return api.post(`/api/users/${id}/photo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  getPhoto: (path) => getPhotoUrl(path)
};

// Serviços de contato
export const contactService = {
  getByUserId: (userId) => api.get(`/api/contacts/user/${userId}`),
  create: (userId, formData) => api.post(`/api/contacts/user/${userId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }),
  update: (userId, contactId, formData) => api.put(`/api/contacts/user/${userId}/${contactId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }),
  delete: (userId, contactId) => api.delete(`/api/contacts/user/${userId}/${contactId}`),
  updatePhoto: (userId, contactId, formData) => {
    return api.post(`/api/contacts/user/${userId}/${contactId}/photo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  getPhoto: (path) => getPhotoUrl(path)
};

// Serviços de lar
export const larService = {
  getAll: () => api.get('/api/lares'),
  create: (data) => api.post('/api/lares', data),
  update: (id, data) => api.put(`/api/lares/${id}`, data),
  delete: (id) => api.delete(`/api/lares/${id}`)
};

// Serviços de pessoa
export const pessoaService = {
  getAll: () => api.get('/api/pessoas'),
  getById: (id) => api.get(`/api/pessoas/${id}`),
  create: (data) => api.post('/api/pessoas', data),
  update: (id, data) => api.put(`/api/pessoas/${id}`, data),
  delete: (id) => api.delete(`/api/pessoas/${id}`),
  uploadPhoto: (id, formData) => {
    console.log(`Chamando API para fazer upload de foto para pessoa com ID ${id}`);
    return api.post(`/api/pessoas/${id}/photo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  getPhoto: (path) => getPhotoUrl(path)
};
